!(function ($) {
    if (null != document.querySelector(".feed-calc-dog")) {
        var breedSelect,
            breed,
            breedSize,
            age,
            is_adult,
            ax,
            weight,
            weight_unit,
            weight_as_adult,
            weight_unit_adult,
            weightInKgs,
            adultWeightInKgs,
            activityLevel,
            desexed,
            bodyCondition,
            dm,
            foodType,
            treats,
            tm,
            kcal,
            grams,
            oz,
            scoops,
            calculate;
        function calculateAll(e) {
            (breedSelect = document.getElementById("breed")),
                (breed = breedSelect.options[breedSelect.selectedIndex].value),
                (breedSize = breedSelect.options[breedSelect.selectedIndex].getAttribute("data-size")),
                (age = document.querySelector("#age").value),
                (weight = document.querySelector("#weight").value),
                (weight_unit = document.querySelector('input[name="weight_in"]:checked').value),
                (weight_as_adult = document.querySelector("#weight_as_adult").value),
                (weight_unit_adult = document.querySelector('input[name ="weight_unit_adult"]:checked').value),
                (activityLevel = document.querySelector("#activity_level").value),
                (desexed = document.querySelector("#desexed").value),
                (bodyCondition = document.querySelector('input[name="body_condition"]:checked').value),
                (food = document.querySelector("#food_type")),
                (foodType = food.options[food.selectedIndex].value),
                (productImage = food.options[food.selectedIndex].getAttribute("data-image")),
                (treats = document.querySelector("#treats").value),
                (kcal = document.querySelector("#kcal")),
                (grams = document.querySelector("#grams")),
                (oz = document.querySelector("#oz")),
                (scoops = document.querySelector("#scoops")),
                (gramsPerScoop = food.options[food.selectedIndex].getAttribute("data-gm-scoop")),
                (kiloCaloriesPerCup = food.options[food.selectedIndex].getAttribute("data-kc-per-cup")),
                "pounds" == weight_unit && ((weightInKgs = (0.453592 * weight) / bodyCondition), $("#grams").hide(), $("#oz").show()),
                "kg" == weight_unit && ((weightInKgs = weight / bodyCondition), $("#grams").show(), $("#oz").hide()),
                "pounds" == weight_unit_adult && (adultWeightInKgs = 0.453592 * weight_as_adult),
                "kg" == weight_unit_adult && (adultWeightInKgs = weight_as_adult),
                (dm = "no" == desexed ? 1.125 : 1),
                (tm = "no" == treats ? 1 : 0.9),
                (ax = 1 == (is_adult = "large" == breedSize ? age > 1.9 : age > 0.9) ? 1 : 3.2 * (Math.exp((weightInKgs / adultWeightInKgs) * -0.87) - 0.1));
            var caloriesRequired = ((85 * Math.pow(weightInKgs, 0.75) * activityLevel) / 100) * ax * dm * tm,
                gramsRequired = caloriesRequired / foodType,
                ozRequired = gramsRequired / 28.3495,
                cupsRequired = caloriesRequired / kiloCaloriesPerCup;
            (kcal.textContent = caloriesRequired.toFixed(0) + " Kcal"),
                (grams.textContent = gramsRequired.toFixed(1) + " g"),
                (oz.textContent = ozRequired.toFixed(1) + " oz"),
                (scoops.innerHTML = cupsRequired.toFixed(1) + " cups"),
                $(".results").show(),
                $("#scoops").show(),
                $("#calc-product").show(),
                $("#calc-product").css("background-image", "url(https://cdn.shopify.com/s/files/1/0696/7551/6062/files/" + productImage + ".png)");

                // Get selected food option
                var food = document.querySelector("#food_type");
                var selectedOption = food.options[food.selectedIndex];
                var productImage = selectedOption.getAttribute("data-image");
                var productUrl = selectedOption.getAttribute("data-product-url");
                var productName = selectedOption.text;
                var firstWordProduct = productName.split(' ')[0];

                // Update recipe title and link
                var recipeLinkEl = document.querySelector('.recipe-link');

                if (recipeLinkEl && productUrl && productName) {
                    recipeLinkEl.href = productUrl;
                    recipeLinkEl.textContent = productName;
                    recipeLinkEl.style.display = '';
                    
                }

        }
        function clearResults() {
            (kcal = document.querySelector("#kcal")),
                (grams = document.querySelector("#grams")),
                (oz = document.querySelector("#oz")),
                (scoops = document.querySelector("#scoops")),
                (kcal.innerHTML = ""),
                (grams.innerHTML = ""),
                (oz.innerHTML = ""),
                (scoops.innerHTML = "");
        }
        function validateForm() {
            var a = document.forms.settings.breed.value,
                b = document.forms.settings.age.value,
                c = document.forms.settings.dog_weight.value;
            if (0 == window.is_adult) {
                var d;
                if (null == (d = document.forms.settings.weight_as_adult.value) || "" == d) return clearResults(), $("#errormessage-adult").show(), !1;
                $("#errormessage-adult").hide();
            } else var d = "not-needed";
            var d = document.forms.settings.weight_as_adult.value,
                e = document.forms.settings.activity_level.value,
                f = document.forms.settings.desexed.value,
                g = document.forms.settings.body_condition.value,
                h = document.forms.settings.treats.value,
                i = document.forms.settings.food_type.value;
            return "" === a || "" === b || "" === c || "" === e || "" === f || "" === g || "" === h || "" === i || calculateAll(), !1;
        }
        $("#age, #breed").change(function () {
            (breedSelect = document.getElementById("breed")),
                (breed = breedSelect.options[breedSelect.selectedIndex].value),
                (breedSize = breedSelect.options[breedSelect.selectedIndex].getAttribute("data-size")),
                "" != (age = document.querySelector("#age").value) &&
                    ("large" == breedSize
                        ? age > 1.9
                            ? ((window.is_adult = !0), $(".weight_two").hide())
                            : ((window.is_adult = !1), $(".weight_two").show())
                        : age > 0.9
                        ? ((window.is_adult = !0), $(".weight_two").hide())
                        : ((window.is_adult = !1), $(".weight_two").show()));
        }),
            $(".feed-calc-dog input, .feed-calc-dog select").change(function () {
                validateForm();
            }),
            $(document).ready(function () {
                $(".calc-select-dog").select2({ width: "style" }), $(".calc-select-dog-no-search").select2({ minimumResultsForSearch: 1 / 0, width: "style" }), validateForm();
            });

            // Step logic
            $(document).ready(function () {
                var $steps = $('.feed-calc-dog .col');
                var currentStep = 0;

                function updateProgress(idx) {
                    var $progressBar = $('.progress-bar');
                    var totalSteps = $('.feed-calc-dog .col').length - 1; // Only first 3 steps show progress
                    if (idx < totalSteps) {
                        $progressBar.show();
                        // Add 'active' to all steps up to and including idx
                        $progressBar.find('.progress-step').removeClass('active').each(function(stepIdx) {
                            if (stepIdx <= idx) {
                                $(this).addClass('active');
                            }
                        });
                        $('#progress-current').text(idx + 1);
                        $('#progress-total').text(totalSteps);
                    } else {
                        $progressBar.hide();
                    }
                }

                function showStep(idx) {
                    $steps.removeClass('active').eq(idx).addClass('active');

                    // Hide all back/next buttons first
                    $steps.find('.back-btn').prop('disabled', true).addClass('disabled');
                    $steps.find('.next-btn').prop('disabled', true).addClass('disabled');

                    // Show and set state for buttons only in the current step
                    var $currentCol = $steps.eq(idx);

                    // Back button: disable and show only on first step, enable and show otherwise
                    if (idx === 0) {
                        $currentCol.find('.back-btn').prop('disabled', true).addClass('disabled');
                    } else {
                        $currentCol.find('.back-btn').prop('disabled', false).removeClass('disabled');
                    }

                    // Next button: hide only on last step, show otherwise
                    if (idx === $steps.length - 1) {
                        $currentCol.find('.next-btn').prop('disabled', true).addClass('disabled');
                    } else {
                        $currentCol.find('.next-btn').prop('disabled', false).removeClass('disabled');
                    }

                    updateProgress(idx);
                }  

                updateProgress(0);

                function validateStep($col) {
                var valid = true;
                $col.find('select[required], input[required]').each(function () {
                    if (!$(this).val()) valid = false;
                });
                return valid;
                }

                // Initial state
                $steps.removeClass('active').eq(0).addClass('active');
                $steps.find('.back-btn').prop('disabled', true).addClass('disabled');
                $steps.last().find('.next-btn').prop('disabled', true).addClass('disabled');

                // Next button logic
                $('.feed-calc-dog').on('click', '.next-btn', function () {
                var $col = $steps.eq(currentStep);
                if (validateStep($col)) {
                    if (currentStep < $steps.length - 1) {
                    currentStep++;
                    showStep(currentStep);
                    }
                } else {
                    // Optionally, show a message or highlight invalid fields
                    $col.find('select[required], input[required]').each(function () {
                    if (!$(this).val()) $(this).addClass('input-error');
                    });
                }
                });

                // Back button logic
                $('.feed-calc-dog').on('click', '.back-btn', function () {
                    console.log('Back button clicked. Current step before:', currentStep);
                    if (currentStep > 0) {
                        currentStep--;
                        console.log('Moved to previous step. Current step now:', currentStep);
                        showStep(currentStep);
                    } else {
                        console.log('Already at first step. No action taken.');
                    }
                });

                // Remove error highlight on input
                $('.feed-calc-dog').on('input change', 'select[required], input[required]', function () {
                    if ($(this).val()) $(this).removeClass('input-error');
                });



                    // Dog name input logic

                    var dogNameInput = document.getElementById('dog-name');
                    var dogNameDisplays = document.querySelectorAll('.dog-name-display');
                    function updateDogName() {
                        var name = dogNameInput.value || "your dog's";
                        dogNameDisplays.forEach(function(el) {
                            el.textContent = name;
                        });
                    }
                    dogNameInput.addEventListener('input', updateDogName);
                    updateDogName();
                    // Calculate button logic
                    $('#settings').on('submit', function(e) {
                        e.preventDefault();

                        // Show spinner, hide text
                        var $btn = $('.send-feed-info .btn');
                        $btn.find('.btn-text').hide();
                        $btn.find('.btn-spinner').show();

                        var payload = {
                            email: $('#email').val(),
                            dog_name: $('#dog-name').val(),
                            breed: $('#breed').val(),
                            age: $('#age').val(),
                            weight: $('#weight').val(),
                            body_condition: $('input[name="body_condition"]:checked').attr('id'),
                            activity_level: $('#activity_level').find('option:selected').data('label'),
                            desexed: $('#desexed').val(),
                            treats: $('#treats').val(),
                            food_type: $('#food_type option:selected').attr('data-image'),
                            kcal_results: $('#kcal').text(),
                            grams_results: $('#grams').text(),
                            oz_results: $('#oz').text(),
                            scoops: $('#scoops').text(),
                            product_url: $('#food_type option:selected').attr('data-product-url'),
                            product_name: $('#food_type option:selected').text(),
                        };

                        console.log('Payload:', payload);

                        $.ajax({
                            url: 'https://animalslikeus.netlify.app/.netlify/functions/klaviyo-subscribe',
                            type: 'POST',
                            data: JSON.stringify(payload),
                            contentType: 'application/json',
                            success: function(response) {
                                document.getElementById('email-result-lead').innerText = 'Drool-worthy plan on the way';
                                document.querySelector('.email.result input#email').placeholder = 'Thanks for signing up'
                                document.getElementById('email').value = '';
                                // Restore button change to sent
                                $btn.find('.btn-text').text('Sent!').show();
                                $btn.find('.btn-spinner').hide();
                                // disable the button prevent further clicks
                                $btn.prop('disabled', true).addClass('disabled');
                                // add class .show-results to .col.fourth
                                $('.col.fourth').addClass('show-results');
                            },
                            error: function(xhr) {
                                var msg = 'There was an error subscribing. Please try again.';
                                var errorObj = xhr.responseJSON;
                                if (!errorObj && xhr.responseText) {
                                    try {
                                        errorObj = JSON.parse(xhr.responseText);
                                    } catch(e) {}
                                }
                                if (xhr.status === 429 && errorObj && errorObj.error) {
                                    msg = errorObj.error;
                                    inputmsg = 'Email already used today';
                                    // add class .show-results to .col.fourth
                                    $('.col.fourth').addClass('show-results');
                                } else if (errorObj && errorObj.error) {
                                    msg = errorObj.error;
                                    inputmsg = 'Error :(';
                                }
                                document.getElementById('email-result-lead').innerText = msg;
                                document.querySelector('.email.result input#email').placeholder = inputmsg;
                                document.getElementById('email').value = '';
                                // Restore button
                                $btn.find('.btn-text').show();
                                $btn.find('.btn-spinner').hide();
                            }
                        });
                    });



                });


    }
})(jQuery);
